[
  {
    "code": "TZ-01",
    "name": "Arusha"
  },
  {
    "code": "TZ-19",
    "name": "Coast"
  },
  {
    "code": "TZ-02",
    "name": "Dar es Salaam"
  },
  {
    "code": "TZ-03",
    "name": "Dodoma"
  },
  {
    "code": "TZ-04",
    "name": "Iringa"
  },
  {
    "code": "TZ-05",
    "name": "Kagera"
  },
  {
    "code": "TZ-08",
    "name": "Kigoma"
  },
  {
    "code": "TZ-09",
    "name": "Kilimanjaro"
  },
  {
    "code": "TZ-12",
    "name": "Lindi"
  },
  {
    "code": "TZ-26",
    "name": "Manyara"
  },
  {
    "code": "TZ-13",
    "name": "Mara"
  },
  {
    "code": "TZ-14",
    "name": "Mbeya"
  },
  {
    "code": "TZ-16",
    "name": "Morogoro"
  },
  {
    "code": "TZ-17",
    "name": "Mtwara"
  },
  {
    "code": "TZ-18",
    "name": "Mwanza"
  },
  {
    "code": "TZ-06",
    "name": "Pemba North"
  },
  {
    "code": "TZ-10",
    "name": "Pemba South"
  },
  {
    "code": "TZ-20",
    "name": "Rukwa"
  },
  {
    "code": "TZ-21",
    "name": "Ruvuma"
  },
  {
    "code": "TZ-22",
    "name": "Shinyanga"
  },
  {
    "code": "TZ-23",
    "name": "Singida"
  },
  {
    "code": "TZ-24",
    "name": "Tabora"
  },
  {
    "code": "TZ-25",
    "name": "Tanga"
  },
  {
    "code": "TZ-07",
    "name": "Zanzibar North"
  },
  {
    "code": "TZ-11",
    "name": "Zanzibar South"
  },
  {
    "code": "TZ-15",
    "name": "Zanzibar West"
  }
]